import React from 'react';

const SvgBlocked: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      d="M12.5 4C8.36 4 5 7.36 5 11.5C5 15.64 8.36 19 12.5 19C16.64 19 20 15.64 20 11.5C20 7.36 16.64 4 12.5 4ZM6.5 11.5C6.5
      8.185 9.185 5.5 12.5 5.5C13.8875 5.5 15.1625 5.9725 16.175 6.7675L7.7675 15.175C6.94372 14.1274 6.49717 12.8327 6.5
      11.5ZM12.5 17.5C11.1125 17.5 9.8375 17.0275 8.825 16.2325L17.2325 7.825C18.0563 8.87259 18.5028 10.1673 18.5 11.5C18.5
      14.815 15.815 17.5 12.5 17.5Z"
      fill="#E22B28"
    />
  </svg>
);

export default SvgBlocked;
